import React from "react";

const SearchControls = ({
  searchValue,
  onSearchChange
}) => (
  <div className="search-controls">
    <label className="input-chip" htmlFor="bothy-search">
      <span className="input-chip__icon" aria-hidden="true">
        ⌕
      </span>
      <input
        id="bothy-search"
        type="text"
        value={searchValue}
        onChange={onSearchChange}
        placeholder="Search by name..."
      />
    </label>
  </div>
);

export default SearchControls;
